import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-em",
  "use": "icon-em-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-em\"><defs><style>#icon-em .cls-1{fill:#004727;}</style></defs><path class=\"cls-1\" d=\"M15.45,3.64,8,8.21.47,3.86a2.19,2.19,0,0,1,2.18-2H13.57a1.82,1.82,0,0,1,1.88,1.81Zm.08,1.53v7a1.76,1.76,0,0,1-1.84,2H2.27c-1.2,0-1.74-.79-1.74-2v-7L7.66,9.61a.71.71,0,0,0,.77,0l0,0Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol